import { INode } from '../../NewFormBuilder/Context/FormBuilderContext';
interface ImageProps {
  node: INode;
}

export function Image({ node }: ImageProps) {
  const styles = node.data.styles;

  return (
    <img
      src={node.data.url}
      alt="Image"
      style={{
        width: '100%',
        height: '100%',
        objectFit: styles?.image?.objectFit || 'cover',
        borderRadius: styles.borderRadius ? styles.borderRadius : 4,
      }}
    />
  );
}
